import axios from 'axios';
import { batch } from 'react-redux';
import { cloneDeep } from 'lodash';
import * as urls from './urlTypes';
import * as types from './actionTypes';
import { toastError } from '../util/toastUtils';
import { getDetailByContractId } from './contractAdminActions';

// synchronous action creator
export const fetchPostsSuccess = posts => ({
  type: 'FETCH_MIDDLE_DATA_SUCCESS',
  payload: posts,
});
export const fetchStudyDataSuccess = data => ({
  type: 'FETCH_STUDY_DATA',
  payload: data,
});
export const fetchPropCodesSuccess = data => ({
  type: 'FETCH_PROP_CODES',
  payload: data,
});
const fetchSelectedLocation = data => ({
  type: 'FETCH_SELECTED_LOCATION',
  payload: data,
});
export const setSelectedContractId = contractId => ({
  type: 'SET_SELECTED_CONTRACT_ID',
  payload: contractId,
});
const setSimmonsLocalMarkets = markets => ({
  type: 'SET_SIMMONS_LOCAL_MARKETS',
  payload: markets,
});
const setMRITopMarkets = markets => ({
  type: 'SET_MRI_TOP_MARKETS',
  payload: markets,
});
export const setMemriUsers = memris => ({
  type: 'SET_MEMRI_USERS',
  payload: memris,
});

export const setEditEntitleName = name => ({
  type: 'SET_EDIT_ENT_NAME',
  payload: name,
});

export const setEditMarkets = markets => ({
  type: 'SET_EDIT_ENT_MARKETS',
  payload: markets,
});
export const setEditMemri = memris => ({
  type: 'SET_EDIT_ENT_MEMRI',
  payload: memris,
});

export const setEditSelectedPropCode = data => ({
  type: 'SET_EDIT_PROP_CODE',
  payload: data,
});

export const setEditSelectedMEMRIUser = data => ({
  type: 'SET_EDIT_MEMRI_USER',
  payload: data,
});

export const setEditSelectedMRIMarket = data => ({
  type: 'SET_EDIT_MRI_MARKET',
  payload: data,
});

export const setPropCodeTypes = list => ({
  type: 'SET_PROP_CODE_TYPES',
  payload: list,
});
export const fetchMiddleData = async () => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/entitlementfeatures`;
  try {
    const posts = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    return posts;
  } catch (e) {
    toastError('Api failed to fetch ProductDeliverable');
    return false;
  }
};
export const getPropCodes = async () => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/propcodes`;
  try {
    const propCodes = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    return propCodes;
  } catch (e) {
    toastError('Api failed to fetch PropCodes');
    return false;
  }
};
export const saveEntitlement = async data => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/entitlements`;
  try {
    const posts = await axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    });

    return posts;
  } catch (e) {
    if (e.response) {
      return {
        error: e.response.data.message,
      };
    }
    toastError('Api failed to Save Entitlement');
    return false;
  }
};

export const saveEntitlementMemri = data => async dispatch => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/getAvailableMemriUsers`;
  try {
    const posts = await axios({
      url,
      method: 'POST',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    });
    const res = posts.data.data;
    const responseType = typeof res;
    if (res && responseType === 'object') {
      batch(() => {
        dispatch(setMemriUsers(posts.data.data));
      });
      return posts;
    }
  } catch (e) {
    try {
      if (e.response) {
        return {
          error: e.response.data.message,
        };
      }
    } catch (e) {
      toastError('Api failed to Update Entitlement');
    }

    return false;
  }
};

export const fetchStudyData = async entId => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/entitlementstudies/${entId}`;
  try {
    const study = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    const responseType = typeof study.data;
    if (study.data && responseType === 'object') {
      return study;
    }
    return false;
  } catch (e) {
    toastError('Api failed to fetch Study Data');
    return false;
  }
};
export const _getLocationResponse = async accountId => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/locations/${accountId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    const responseType = typeof response.data;
    if (response.data && responseType === 'object') {
      return response.data;
    }
    return response.data;
  } catch (error) {
    toastError('Api failed to fetch Locations');
    return false;
  }
};
export const getAccountsLocations = (
  accountId,
  entId,
  isTPPAccountSelected
) => async dispatch => {
  batch(() => {
    dispatch(setEditSelectedPropCode([]));
    dispatch(fetchPostsSuccess([]));
    dispatch(setEditMarkets([]));
    dispatch(setEditMemri([]));
    dispatch(fetchStudyDataSuccess([]));
    dispatch(fetchPropCodesSuccess([]));
    dispatch(fetchSelectedLocation([]));
  });
  const locations = await _getLocationResponse(accountId);
  const study = await fetchStudyData(entId);
  const posts = await fetchMiddleData(entId);
  const propCodes = await getPropCodes();
  batch(() => {
    dispatch({
      type: types.GET_ACCOUNTS_LOCATIONS,
      payload: locations,
    });
    if (study) {
      dispatch(fetchStudyDataSuccess(study.data.data));
    }
    if (propCodes) {
      dispatch(fetchPropCodesSuccess(propCodes.data.data.propCodes));
    }
    const prodData =
      posts && setDefault(posts.data.data, isTPPAccountSelected, true);
    if (prodData) dispatch(fetchPostsSuccess(prodData));
    if (locations.data.length === 1) {
      dispatch(fetchSelectedLocation(locations.data));
    }
  });
};
const setProdChildSel = prodData => {
  prodData.map(item => {
    if (item.modules) {
      item.modules.map(child => {
        if (child.modules) {
          const isAnyChildSelected = child.modules.some(
            e => e.selected === true || e.isAnyChildSelected
          );
          const isAllChecked = child.modules.every(e => e.selected === true);
          child.isAnyChildSelected =
            !child.selected && !isAllChecked && isAnyChildSelected;
        }
        return child;
      });
    }
    if (item.modules && item.modules.length) {
      const isAnyChildSelected = item.modules.some(
        e => e.selected === true || e.isAnyChildSelected
      );
      const isAllChecked = item.modules.every(e => e.selected === true);
      item.isAnyChildSelected =
        !item.selected && !isAllChecked && isAnyChildSelected;
    }
    return item;
  });
  return prodData;
};
const setIsAnychildSelected = e => {
  e.isAnyChildSelected = false;
  const isAnyChildSel = e.nodes.some(e => e.selected === true);
  const isChildDataSelected = e.nodes.some(e => e.isAnyChildSelected === true);
  const isAllChecked = e.nodes.every(e => e.selected === true);
  e.selected = e.selected ? e.selected : isAllChecked;
  e.isAnyChildSelected = (isChildDataSelected || isAnyChildSel) && !e.selected;
  return e;
};

const setIsAnyChildSel = d1 => {
  const data = cloneDeep(d1);
  data.map(e => {
    e.nodes.map(e1 => {
      if (e1.nodes) {
        e1.nodes.map(e2 => {
          e2.isAnyChildSelected = false;
          if (e2.nodes) {
            const isAnyChildSel = e2.nodes.some(year => year.selected === true);
            const isAllChecked = e2.nodes.every(year => year.selected === true);
            e2.isAnyChildSelected =
              isAnyChildSel && !isAllChecked && !e2.selected;
          }
          return e2;
        });
      }
      return e1;
    });
    return e;
  });
  data.map(e => {
    e.isAnyChildSelected = false;
    e.nodes.map(e1 => {
      if (e1.nodes) {
        setIsAnychildSelected(e1);
      }
      return e1;
    });
    return e;
  });
  data.map(e => {
    setIsAnychildSelected(e);
    return e;
  });
  return data;
};
const setDefault = (data, isTPPAccountSelected, isAdd) => {
  data.map(e => {
    if (e.optionName === 'Third Party Provider' && isTPPAccountSelected) {
      e.disable = true;
      if (isAdd) {
        !e.isAnyChildSelected ? (e.selected = true) : (e.selected = false);

        e.modules.map(e => {
          e.selected = true;
          return e;
        });
      }
    }
    if (e.optionName === 'Resources') {
      e.selected = true;
      e.disable = true;
    } else if (
      isTPPAccountSelected &&
      e.optionName !== 'Third Party Provider'
    ) {
      e.disable = true;
      e.disableText = true;
    }
    return e;
  });
  return data;
};
export const getEntitlementById = (
  selectedEntitlementId,
  accountId,
  isTPPAccountSelected,
  propCode
) => async dispatch => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/entitlements?id=${selectedEntitlementId}`;

  try {
    const propCodes = !propCode.length && (await getPropCodes());
    const study = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    const res = study.data.data;
    const responseType = typeof res;
    const locations = await _getLocationResponse(accountId);
    batch(() => {
      if (propCodes) {
        dispatch(fetchPropCodesSuccess(propCodes.data.data.propCodes));
      }
      dispatch({
        type: types.GET_ACCOUNTS_LOCATIONS,
        payload: locations,
      });

      if (res && responseType === 'object') {
        const studies = setIsAnyChildSel(res.entitlementDtos);
        dispatch(fetchStudyDataSuccess([...studies]));
        const data =
          res.entitlementFeatureSetDtos &&
          setProdChildSel(res.entitlementFeatureSetDtos);
        setDefault(data, isTPPAccountSelected);
        dispatch(fetchPostsSuccess(data));

        dispatch(fetchSelectedLocation(res.entitlementLocationDtos));
        dispatch(setSelectedContractId(res.contractId));
        dispatch(setEditEntitleName(res.entitlementName));
        dispatch(setEditMarkets(res.dmaMarkets ? res.dmaMarkets : []));
        dispatch(
          setEditMemri(
            res.memriUsersSelectedDtos ? res.memriUsersSelectedDtos : []
          )
        );

        const selectedPropCode = propCode.length
          ? propCode.filter(i1 => res.propCodeIds.includes(i1.id))
          : propCodes.data.data.propCodes.filter(i1 =>
              res.propCodeIds.includes(i1.id)
            );
        dispatch(setEditSelectedPropCode([...selectedPropCode]));

        dispatch(getDetailByContractId(res.contractId));
      }
    });
  } catch (e) {
    toastError('Api failed to fetch Entitlement Data');
    return false;
  }
};
export const updateEntitlement = (
  data,
  isTPPAccountSelected,
  propCodes
) => async dispatch => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/entitlements`;
  try {
    const posts = await axios({
      url,
      method: 'POST',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    });
    const res = posts.data.data;
    const responseType = typeof res;
    if (res && responseType === 'object') {
      const studies = setIsAnyChildSel(res.entitlementDtos);
      const data =
        res.entitlementFeatureSetDtos &&
        setProdChildSel(res.entitlementFeatureSetDtos);
      batch(() => {
        const prodData = setDefault(data, isTPPAccountSelected);
        dispatch(fetchPostsSuccess(prodData));
        dispatch(fetchStudyDataSuccess(studies));
        dispatch(fetchSelectedLocation(res.entitlementLocationDtos));
        dispatch(setSelectedContractId(res.contractId));
        dispatch(setEditEntitleName(res.entitlementName));
        dispatch(setEditMarkets(res.dmaMarkets ? res.dmaMarkets : []));
        dispatch(
          setEditMemri(
            res.memriUsersSelectedDtos ? res.memriUsersSelectedDtos : []
          )
        );

        const selectedPropCode = propCodes.filter(i1 =>
          res.propCodeIds.includes(i1.id)
        );
        dispatch(setEditSelectedPropCode(selectedPropCode || []));
      });
      return posts;
    }
    toastError('Api failed to fetch Entitlement Data');

    return posts;
  } catch (e) {
    try {
      if (e.response) {
        return {
          error: e.response.data.message,
        };
      }
    } catch (e) {
      toastError('Api failed to Update Entitlement');
    }

    return false;
  }
};

export const getDmaMarkets = () => async dispatch => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/dmamarkets`;
  try {
    const markets = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    const res = markets.data.data;
    const responseType = typeof res;
    if (res && responseType === 'object') {
      const localMarkets = res.dmaMarkets.filter(data => data.studySource == 1);
      const topMarkets = res.dmaMarkets.filter(data => data.studySource == 2);
      batch(() => {
        dispatch(setSimmonsLocalMarkets(localMarkets));
        dispatch(setMRITopMarkets(topMarkets));
      });
      return {
        localMarkets,
        topMarkets,
      };
    }
    toastError('Api failed to fetch Market list Data');
  } catch (e) {
    toastError('Api failed to fetch Market List Data');
    return false;
  }
};

export const createPropCode = data => async dispatch => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/propcodes`;
  try {
    const propCodes = await axios({
      url,
      method: 'post',
      headers: {
        accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      data,
    });
    propCodes.data.data &&
      propCodes.data.data.allPropCodes &&
      dispatch(fetchPropCodesSuccess(propCodes.data.data.allPropCodes));
    return propCodes.data;
  } catch (e) {
    if (e.response) {
      return {
        error: e.response.data.message,
      };
    }
    toastError('Api failed to Generate PropCode');
    return false;
  }
};

export const getPropCodeTypes = () => async dispatch => {
  const url = `${urls.API_GATEWAY_URL}/api/contracts-admin-service/propcodeTypes`;
  try {
    const types = await axios({
      url,
      method: 'get',
      withCredentials: true,
      responseType: 'json',
    });
    const res = types.data.data.propCodeTypes;
    const responseType = typeof res;
    if (res && responseType === 'object') {
      dispatch(setPropCodeTypes(res));
    } else {
      toastError('Api failed to fetch ProCodeTypes');
    }
  } catch (e) {
    toastError('Api failed to fetch ProCodeTypes');
    return false;
  }
};
